import * as React from "react";

function EURedesign(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0)">
            <path d="M14 0.500002C21.4558 0.500002 27.5 6.54416 27.5 14C27.5 21.4558 21.4558 27.5 14 27.5C6.54416 27.5 0.5 21.4558 0.5 14C0.5 6.54416 6.54416 0.500002 14 0.500002Z" fill="#3A8FF0" stroke="#74B3FA"/>
            <path d="M17.0131 11.2614V17.5599C17.0131 17.7354 16.8782 17.8776 16.7118 17.8776H11.2883C11.1219 17.8776 10.987 17.7354 10.987 17.5599V11.2614H8.70133C8.53492 11.2614 8.40002 11.1192 8.40002 10.9438C8.40002 10.8595 8.43177 10.7787 8.48827 10.7192L13.787 5.13304C13.9046 5.00899 14.0954 5.00899 14.2131 5.13304L19.5118 10.7192C19.6294 10.8432 19.6294 11.0443 19.5118 11.1684C19.4553 11.228 19.3786 11.2614 19.2987 11.2614H17.0131ZM11.2883 19.1482H16.7118C16.8782 19.1482 17.0131 19.2904 17.0131 19.4658V20.1011C17.0131 20.2766 16.8782 20.4188 16.7118 20.4188H11.2883C11.1219 20.4188 10.987 20.2766 10.987 20.1011V19.4658C10.987 19.2904 11.1219 19.1482 11.2883 19.1482ZM11.2883 21.6894H16.7118C16.8782 21.6894 17.0131 21.8316 17.0131 22.0071V22.6424C17.0131 22.8178 16.8782 22.96 16.7118 22.96H11.2883C11.1219 22.96 10.987 22.8178 10.987 22.6424V22.0071C10.987 21.8316 11.1219 21.6894 11.2883 21.6894Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="28" height="28" fill="white"/>
            </clipPath>
        </defs>
    </svg>
  );
}

export default EURedesign;

